import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo-dark.svg'


const _hoisted_1 = { class: "max-w-full w-full bg-primary-gray text-white flex justify-center items-start gap-28 py-7 px-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-32"
}, null, -1)
const _hoisted_3 = { class: "flex flex-col gap-5" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "flex flex-col gap-5 items-start" }
const _hoisted_6 = { class: "flex flex-col gap-5 items-start max-w-[200px]" }

import NavItem from "./nav-item.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'footer-lg',
  setup(__props) {

const footerItems = {
  services: [
    { title: "Family Space", link: "#family-space" },
    { title: "Commercial", link: "#commercial" },
    { title: "Putting Greens", link: "#putting-greens" },
    { title: "Happy Pets", link: "#happy-pets" },
    { title: "Landscape Lightings", link: "#lighting" },
  ],
  locations: ["Hamilton", "Burlington", "St. Catharines", "Niagra"],
  contact: [
    "info@perfectgreen.ca",
    "+1 (905) 674-5983",
    "",
  ],
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerItems.services, (item) => {
        return (_openBlock(), _createBlock(NavItem, {
          key: item.title
        }, {
          default: _withCtx(() => [
            _createElementVNode("a", {
              href: item.link
            }, _toDisplayString(item.title), 9, _hoisted_4)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerItems.locations, (item) => {
        return (_openBlock(), _createElementBlock("div", { key: item }, _toDisplayString(item), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerItems.contact, (item) => {
        return (_openBlock(), _createElementBlock("div", { key: item }, _toDisplayString(item), 1))
      }), 128))
    ])
  ]))
}
}

})